/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: useLogProfilesColumns.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Hook for defining Log Profiles DataGrid columns.
────────────────────────────────────────────────────────────────*/

import { useMemo } from 'react';
import { useI18n } from '../../../hooks/useI18n';
import { DataGridColumn } from '../../../hooks/useDataGrid';

export function useLogProfilesColumns() {
  const { t } = useI18n();

  const availableColumns = useMemo<DataGridColumn[]>(
    () => [
      { key: 'name', label: t('logProfiles.columns.name'), visible: true, sortable: true },
      { key: 'description', label: t('logProfiles.columns.description'), visible: true, sortable: false },
      { key: 'modulesCount', label: t('logProfiles.columns.modules'), visible: true, sortable: true },
      { key: 'usersCount', label: t('logProfiles.columns.users'), visible: true, sortable: true },
      { key: 'created_at', label: t('logProfiles.columns.created'), visible: true, sortable: true },
      { key: 'updated_at', label: t('logProfiles.columns.modified'), visible: true, sortable: true },
      { key: 'actions', label: t('logProfiles.actions.label'), visible: true, sortable: false },
    ],
    [t],
  );

  return availableColumns;
}

